// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 70 ? "npm.regenerator-runtime" : chunkId) + "." + {"70":"25dfca19","776":"6de0804a"}[chunkId] + ".chunk.js";
};